import { enumZoneType, ZoneType } from '@rematter/frontend-lib-api-client';
import { Badge } from '@rematter/ui-web';

import { useTranslations } from '../../i18n/useTranslations';

type ZoneTypeBadgeProps = {
  zoneType: ZoneType;
};

const TYPE_BADGE_COLOR: Record<
  ZoneType,
  'neutral' | 'primary' | 'success' | 'warning' | 'failure'
> = {
  [enumZoneType.Zone]: 'primary',
  [enumZoneType.Aisle]: 'success',
  [enumZoneType.Shelf]: 'warning',
  [enumZoneType.Bin]: 'neutral',
  [enumZoneType.Other]: 'neutral',
};

export const ZoneTypeBadge = ({ zoneType }: ZoneTypeBadgeProps) => {
  const t = useTranslations();

  return (
    <Badge color={TYPE_BADGE_COLOR[zoneType]} className="@ZoneTypeBadge">
      {t.zonesListView.zoneTypes[zoneType]}
    </Badge>
  );
};
